@let isCellView = isCellView$ | async;

<div class="d-flex align-items-center">
  @if (!isQuickCreationCardOpen) {
    <fa-icon class="view-icon card-open px-3" [icon]="faListAlt"></fa-icon>
  }

  <div
    class="search"
    [ngClass]="isQuickCreationCardOpen ? 'card-open ps-3' : 'card-close'"
  >
    <div class="wrapper">
      @if (isQuickCreationCardOpen) {
        <p class="mb-0">
          {{ 'page.shift_timeline.shift_templates_tab' | translate }}
        </p>
      }
      @if (isQuickCreationCardOpen) {
        <wilson-shift-template-select
          class="shift-template-input"
          [isShiftTemplateDropDownOpen]="isShiftTemplateDropDownOpen"
          (opened)="isShiftTemplateDropDownOpen = $event"
          [selectedShiftTemplate]="selectedShiftTemplate"
          (selectedShiftTemplateChange)="selectTemplate($event)"
          (startDrag)="startDrag($event)"
          (endDrag)="dragEnd()"
        ></wilson-shift-template-select>
      }
    </div>
  </div>

  @if (
    {
      emptyShiftVisible:
        'portal-shift-timeline-quick-shift-creation' | featureFlagPure | async,
      newAbsenceVisible:
        'Shift-timeline-page-create-new-absence' | featureFlagPure | async,
      emptyActivity:
        'portal-shift-timeline-quick-activity-creation'
        | featureFlagPure
        | async,
    };
    as data
  ) {
    <div class="d-flex action-bar" [class.px-3]="isQuickCreationCardOpen">
      <div
        class="m-auto"
        [ngClass]="isQuickCreationCardOpen ? 'card-open' : 'card-close'"
      >
        <wilson-shift-quick-creation-from-template-card
          [isQuickCreationCardOpen]="isQuickCreationCardOpen"
        ></wilson-shift-quick-creation-from-template-card>
      </div>
      @if (data.emptyShiftVisible) {
        <div
          class="m-auto"
          [ngClass]="isQuickCreationCardOpen ? 'card-open' : 'card-close'"
        >
          <wilson-new-shift-quick-creation-card
            [isQuickCreationCardOpen]="isQuickCreationCardOpen"
          ></wilson-new-shift-quick-creation-card>
        </div>
      }
      @if (data.newAbsenceVisible) {
        <div
          class="m-auto"
          [ngClass]="isQuickCreationCardOpen ? 'card-open ms-2' : 'card-close'"
        >
          <wilson-new-absence-quick-action-card
            [isQuickCreationCardOpen]="isQuickCreationCardOpen"
          ></wilson-new-absence-quick-action-card>
        </div>
      }
      @if (data.emptyActivity) {
        <div
          class="m-auto"
          [ngClass]="isQuickCreationCardOpen ? 'card-open ms-2' : 'card-close'"
        >
          <wilson-new-activity-quick-creation-card
            [isQuickCreationCardOpen]="isQuickCreationCardOpen"
            [disabled]="!!isCellView"
          ></wilson-new-activity-quick-creation-card>
        </div>
      }
    </div>
  }
</div>
